/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddUserBonusTokenBalanceTokenRequest,
  AuthTokenResponse,
  CheckPayoutMethodUpdateStatusResponse,
  CheckUserBonusTokenBalanceTokenRequest,
  CheckUserBonusTokenBalanceTokenResponse,
  CreateFollowerDto,
  CreateGuestUserRequest,
  CreateLeadsContactRequest,
  CreateUserParamsV2,
  GetPhoneResponse,
  GetSellerMetricsResponse,
  IdResponse,
  OneTimeLoginCodeDto,
  SellerBalanceResponse,
  SetUrlCodeDto,
  StripePayoutMethodResponse,
  UpdateUserParamsV2,
} from '../models/index';

export interface UserApiControllerAddUserTokenBalanceBonusTokenRequest {
    userId: string;
    AddUserBonusTokenBalanceTokenRequest: AddUserBonusTokenBalanceTokenRequest;
}

export interface UserApiControllerCheckPayoutMethodUpdateStatusRequest {
    userId: string;
}

export interface UserApiControllerCheckUserTokenBalanceBonusTokenRequest {
    userId: string;
    CheckUserBonusTokenBalanceTokenRequest: CheckUserBonusTokenBalanceTokenRequest;
}

export interface UserApiControllerCreateFollowerRequest {
    userId: string;
    CreateFollowerDto: CreateFollowerDto;
}

export interface UserApiControllerCreateGuestUserRequest {
    CreateGuestUserRequest: CreateGuestUserRequest;
    x_pop_platform?: UserApiControllerCreateGuestUserXPopPlatformEnum;
}

export interface UserApiControllerCreateLeadsContactRequest {
    CreateLeadsContactRequest: CreateLeadsContactRequest;
}

export interface UserApiControllerCreateUserV2Request {
    userId: string;
    CreateUserParamsV2: CreateUserParamsV2;
}

export interface UserApiControllerExchangeOneTimeLoginCodeRequest {
    OneTimeLoginCodeDto: OneTimeLoginCodeDto;
}

export interface UserApiControllerGetBalanceRequest {
    userId: string;
}

export interface UserApiControllerGetPhoneRequest {
    phone: string;
}

export interface UserApiControllerGetSellerMetricsRequest {
    sellerId: string;
}

export interface UserApiControllerGetStripePayoutMethodRequest {
    userId: string;
}

export interface UserApiControllerRemoveFollowerRequest {
    userId: string;
    followerId: string;
}

export interface UserApiControllerSetProfileUrlCodeRequest {
    userId: string;
    SetUrlCodeDto: SetUrlCodeDto;
}

export interface UserApiControllerUpdateUserV2Request {
    userId: string;
    UpdateUserParamsV2: UpdateUserParamsV2;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * for users to add bonus tokens to a user\'s token balance
     */
    async userApiControllerAddUserTokenBalanceBonusTokenRaw(requestParameters: UserApiControllerAddUserTokenBalanceBonusTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerAddUserTokenBalanceBonusToken().'
            );
        }

        if (requestParameters['AddUserBonusTokenBalanceTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'AddUserBonusTokenBalanceTokenRequest',
                'Required parameter "AddUserBonusTokenBalanceTokenRequest" was null or undefined when calling userApiControllerAddUserTokenBalanceBonusToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/token-balance-changes:add-bonus-tokens`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AddUserBonusTokenBalanceTokenRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * for users to add bonus tokens to a user\'s token balance
     */
    async userApiControllerAddUserTokenBalanceBonusToken(requestParameters: UserApiControllerAddUserTokenBalanceBonusTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerAddUserTokenBalanceBonusTokenRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userApiControllerCheckPayoutMethodUpdateStatusRaw(requestParameters: UserApiControllerCheckPayoutMethodUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckPayoutMethodUpdateStatusResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerCheckPayoutMethodUpdateStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}:checkPayoutMethodUpdateStatus`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCheckPayoutMethodUpdateStatus(requestParameters: UserApiControllerCheckPayoutMethodUpdateStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckPayoutMethodUpdateStatusResponse> {
        const response = await this.userApiControllerCheckPayoutMethodUpdateStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * for users to check bonus tokens to a user\'s token balance
     */
    async userApiControllerCheckUserTokenBalanceBonusTokenRaw(requestParameters: UserApiControllerCheckUserTokenBalanceBonusTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckUserBonusTokenBalanceTokenResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerCheckUserTokenBalanceBonusToken().'
            );
        }

        if (requestParameters['CheckUserBonusTokenBalanceTokenRequest'] == null) {
            throw new runtime.RequiredError(
                'CheckUserBonusTokenBalanceTokenRequest',
                'Required parameter "CheckUserBonusTokenBalanceTokenRequest" was null or undefined when calling userApiControllerCheckUserTokenBalanceBonusToken().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/token-balance-changes:check-bonus-tokens`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CheckUserBonusTokenBalanceTokenRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * for users to check bonus tokens to a user\'s token balance
     */
    async userApiControllerCheckUserTokenBalanceBonusToken(requestParameters: UserApiControllerCheckUserTokenBalanceBonusTokenRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckUserBonusTokenBalanceTokenResponse> {
        const response = await this.userApiControllerCheckUserTokenBalanceBonusTokenRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateFollowerRaw(requestParameters: UserApiControllerCreateFollowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerCreateFollower().'
            );
        }

        if (requestParameters['CreateFollowerDto'] == null) {
            throw new runtime.RequiredError(
                'CreateFollowerDto',
                'Required parameter "CreateFollowerDto" was null or undefined when calling userApiControllerCreateFollower().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/followers`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateFollowerDto'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateFollower(requestParameters: UserApiControllerCreateFollowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerCreateFollowerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userApiControllerCreateGuestUserRaw(requestParameters: UserApiControllerCreateGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthTokenResponse>> {
        if (requestParameters['CreateGuestUserRequest'] == null) {
            throw new runtime.RequiredError(
                'CreateGuestUserRequest',
                'Required parameter "CreateGuestUserRequest" was null or undefined when calling userApiControllerCreateGuestUser().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['x_pop_platform'] != null) {
            headerParameters['x-pop-platform'] = String(requestParameters['x_pop_platform']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/guest-users`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateGuestUserRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateGuestUser(requestParameters: UserApiControllerCreateGuestUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthTokenResponse> {
        const response = await this.userApiControllerCreateGuestUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateLeadsContactRaw(requestParameters: UserApiControllerCreateLeadsContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters['CreateLeadsContactRequest'] == null) {
            throw new runtime.RequiredError(
                'CreateLeadsContactRequest',
                'Required parameter "CreateLeadsContactRequest" was null or undefined when calling userApiControllerCreateLeadsContact().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/leads-contacts`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateLeadsContactRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateLeadsContact(requestParameters: UserApiControllerCreateLeadsContactRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<IdResponse> {
        const response = await this.userApiControllerCreateLeadsContactRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateOneTimeLoginCodeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OneTimeLoginCodeDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/one-time-login-codes`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateOneTimeLoginCode(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OneTimeLoginCodeDto> {
        const response = await this.userApiControllerCreateOneTimeLoginCodeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerCreateUserV2Raw(requestParameters: UserApiControllerCreateUserV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerCreateUserV2().'
            );
        }

        if (requestParameters['CreateUserParamsV2'] == null) {
            throw new runtime.RequiredError(
                'CreateUserParamsV2',
                'Required parameter "CreateUserParamsV2" was null or undefined when calling userApiControllerCreateUserV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['CreateUserParamsV2'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerCreateUserV2(requestParameters: UserApiControllerCreateUserV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerCreateUserV2Raw(requestParameters, initOverrides);
    }

    /**
     */
    async userApiControllerExchangeOneTimeLoginCodeRaw(requestParameters: UserApiControllerExchangeOneTimeLoginCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthTokenResponse>> {
        if (requestParameters['OneTimeLoginCodeDto'] == null) {
            throw new runtime.RequiredError(
                'OneTimeLoginCodeDto',
                'Required parameter "OneTimeLoginCodeDto" was null or undefined when calling userApiControllerExchangeOneTimeLoginCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/one-time-login-codes:exchange`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['OneTimeLoginCodeDto'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerExchangeOneTimeLoginCode(requestParameters: UserApiControllerExchangeOneTimeLoginCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthTokenResponse> {
        const response = await this.userApiControllerExchangeOneTimeLoginCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetBalanceRaw(requestParameters: UserApiControllerGetBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SellerBalanceResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerGetBalance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}:getSellerBalance`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetBalance(requestParameters: UserApiControllerGetBalanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SellerBalanceResponse> {
        const response = await this.userApiControllerGetBalanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetPhoneRaw(requestParameters: UserApiControllerGetPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPhoneResponse>> {
        if (requestParameters['phone'] == null) {
            throw new runtime.RequiredError(
                'phone',
                'Required parameter "phone" was null or undefined when calling userApiControllerGetPhone().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/user-phones/{phone}`;
        urlPath = urlPath.replace(`{${"phone"}}`, encodeURIComponent(String(requestParameters['phone'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetPhone(requestParameters: UserApiControllerGetPhoneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPhoneResponse> {
        const response = await this.userApiControllerGetPhoneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Public API
     */
    async userApiControllerGetSellerMetricsRaw(requestParameters: UserApiControllerGetSellerMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetSellerMetricsResponse>> {
        if (requestParameters['sellerId'] == null) {
            throw new runtime.RequiredError(
                'sellerId',
                'Required parameter "sellerId" was null or undefined when calling userApiControllerGetSellerMetrics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/stores/{sellerId}/metrics`;
        urlPath = urlPath.replace(`{${"sellerId"}}`, encodeURIComponent(String(requestParameters['sellerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     * Public API
     */
    async userApiControllerGetSellerMetrics(requestParameters: UserApiControllerGetSellerMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetSellerMetricsResponse> {
        const response = await this.userApiControllerGetSellerMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerGetStripePayoutMethodRaw(requestParameters: UserApiControllerGetStripePayoutMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePayoutMethodResponse>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerGetStripePayoutMethod().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}:stripePayoutMethod`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async userApiControllerGetStripePayoutMethod(requestParameters: UserApiControllerGetStripePayoutMethodRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePayoutMethodResponse> {
        const response = await this.userApiControllerGetStripePayoutMethodRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userApiControllerRemoveFollowerRaw(requestParameters: UserApiControllerRemoveFollowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerRemoveFollower().'
            );
        }

        if (requestParameters['followerId'] == null) {
            throw new runtime.RequiredError(
                'followerId',
                'Required parameter "followerId" was null or undefined when calling userApiControllerRemoveFollower().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}/followers/{followerId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));
        urlPath = urlPath.replace(`{${"followerId"}}`, encodeURIComponent(String(requestParameters['followerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerRemoveFollower(requestParameters: UserApiControllerRemoveFollowerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerRemoveFollowerRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userApiControllerSetProfileUrlCodeRaw(requestParameters: UserApiControllerSetProfileUrlCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerSetProfileUrlCode().'
            );
        }

        if (requestParameters['SetUrlCodeDto'] == null) {
            throw new runtime.RequiredError(
                'SetUrlCodeDto',
                'Required parameter "SetUrlCodeDto" was null or undefined when calling userApiControllerSetProfileUrlCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/users/{userId}:set-url-code`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetUrlCodeDto'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerSetProfileUrlCode(requestParameters: UserApiControllerSetProfileUrlCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerSetProfileUrlCodeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async userApiControllerUpdateUserV2Raw(requestParameters: UserApiControllerUpdateUserV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['userId'] == null) {
            throw new runtime.RequiredError(
                'userId',
                'Required parameter "userId" was null or undefined when calling userApiControllerUpdateUserV2().'
            );
        }

        if (requestParameters['UpdateUserParamsV2'] == null) {
            throw new runtime.RequiredError(
                'UpdateUserParamsV2',
                'Required parameter "UpdateUserParamsV2" was null or undefined when calling userApiControllerUpdateUserV2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v2/users/{userId}`;
        urlPath = urlPath.replace(`{${"userId"}}`, encodeURIComponent(String(requestParameters['userId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateUserParamsV2'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userApiControllerUpdateUserV2(requestParameters: UserApiControllerUpdateUserV2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userApiControllerUpdateUserV2Raw(requestParameters, initOverrides);
    }

}

/**
 * @export
 */
export const UserApiControllerCreateGuestUserXPopPlatformEnum = {
    Psl: 'psl',
    Popstore: 'popstore'
} as const;
export type UserApiControllerCreateGuestUserXPopPlatformEnum = typeof UserApiControllerCreateGuestUserXPopPlatformEnum[keyof typeof UserApiControllerCreateGuestUserXPopPlatformEnum];
